import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Media, Modal, ModalBody, Button, Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faStar, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import { teamActions } from '../../../core/teams';
import { teamsReportListActions } from '../../../core/teams-report';

import graphic_report from '../../../assets/img/graphic-report-collapsed-sm.svg';
import { getTeamMemberById, teamsMemberActions } from '../../../core/teams-members';

const MemberDetail = (props) => {
  const {
    hanndleNextSection,
    userId,
    team,
    enable_edit,
    loadTeamsReport,
    removeTeamMember,
    setLeaderTeamMember
  } = props;

  const dispatch = useDispatch();
  const teamMemberData = useSelector(state => getTeamMemberById(state, userId));
  const member = teamMemberData?.member;
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if(!member?.user_id && !member?.isLoading) {
      dispatch(teamsMemberActions.fetchTeamMemberById({ teamsMemberId: userId, teamId: team.id }));
    }
  }, []);

  const handleModal = (e, confirm = false) => {
    if (confirm && showModal) {
      handleActionMember({ section: 'remove-member', member_id: member.id });
      loadTeamsReport(team.id);
    }
    setShowModal(!showModal);
  };

  const handleActionMember = ({ section = 'members-list', member_id = null }) => {
    if (section === 'set-member-leader') {
      setLeaderTeamMember(team.id, member_id);
    }

    if (section === 'remove-member') {
      removeTeamMember(team.id, member_id);
    }

    hanndleNextSection({ section, member_id });
  };

  if (!teamMemberData?.user_id || teamMemberData?.isPending) {
    return <div className="d-flex justify-content-center align-content-end mt-5">
      <Spinner color="primary" style={{ height: '3rem', width: '3rem' }} />
    </div>;
  }

  const ttCompleted = member.talents.some(talent => talent.items.length);

  return (
    <>
      <div className="d-md-flex justify-content-between mb-3 align-items-center">
        <Media className="align-items-center mt-2">
          <Media left className="pr-3 cursor-pointer">
            <img className="media-object" width="40" height="40" src={member.avatar} alt={member.first_name} />
          </Media>
          <Media body>
            <Media heading tag="p" className="mb-n1 mt-1">{(member.first_name) ? `${member.first_name} ${member.last_name}` : member.username}</Media>
            <p className="text-reset line-height-normal mb-2"><small>{member.seniority ? member.seniority.name : ''}</small></p>
          </Media>
        </Media>

        <div className='botones'>
          {enable_edit &&
            <>
              <button onClick={(e) => { e.preventDefault(); handleModal(e) }}
                className="btn text-uppercase rounded-pill btn-outline-primary mx-auto px-md-4 mb-3 mb-md-0">
                <i className="mr-3 h5 text-reset align-middle"><FontAwesomeIcon icon={faTimesCircle} /></i>
                Remove From Team
              </button>

              {(member.isLeader === 0) &&
                <button onClick={(e) => { e.preventDefault(); handleActionMember({ section: 'set-member-leader', member_id: member.id }) }}
                  className="btn text-uppercase rounded-pill btn-outline-primary mx-auto px-md-4 ml-md-3 mb-3 mb-md-0"><i className="mr-3 h5 text-reset align-middle"><FontAwesomeIcon icon={faStar} /></i>
                  Set as Team Leader
                </button>
              }

              {(member.isLeader === 1) &&
                <button onClick={(e) => { e.preventDefault(); handleActionMember({ section: 'set-member-leader', member_id: member.id }) }}
                  className="btn text-uppercase rounded-pill btn-outline-primary mx-auto px-md-4 ml-md-3 mb-3 mb-md-0"><i className="mr-3 h5 text-reset align-middle"><FontAwesomeIcon icon={faTimesCircle} /></i>
                  Remove as Team Leader
                </button>
              }
            </>
          }
        </div>
      </div>

      <div className='overflow-hidden'>
        {/*THINKING TALENT REPORT*/}
        {ttCompleted && <div className='text-center mb-3'>
          <h5>Thinking Talent</h5>
          <div className="py-2 justify-content-center align-items-stretch d-flex">
            <div className="px-0 d-flex flex-column text-right" style={{ width: '88px' }}>
              <div className="cursor-pointer mt-auto border-bottom pr-2">
                <h6 className="mb-0 font-weight-medium small py-2" >Analytic
                  <span className='pl-1 font-weight-bold h6'>
                    {
                      member.talents &&
                      member.talents.map(quadrant =>
                        quadrant.quadrant === 'Analytic' &&
                        quadrant?.counts?.always
                      )
                    }
                  </span>
                </h6>
              </div>
              <div className="cursor-pointer mb-auto pr-2">
                <h6 className="mb-0 font-weight-medium small py-2">
                  Procedural
                  <span className='pl-1 font-weight-bold h6'>
                    {
                      member.talents &&
                      member.talents.map(quadrant =>
                        quadrant.quadrant === 'Procedural' &&
                        quadrant?.counts?.always
                      )
                    }
                  </span>
                </h6>
              </div>
            </div>

            <div className="bg-map-dk">
              <div className="mx-auto" style={{ width: '88px' }}>
                <div className="mx-auto text-center graphic-list-all-talent-collapsed d-flex flex-column align-items-center justify-content-center">
                  <h6 className="text-center mb-0 font-weight-medium small" >All</h6>
                  <span className='font-weight-bold h6'>
                    {
                      member.talents &&
                      member.talents.map(quadrant =>
                        quadrant.quadrant === 'All' &&
                        quadrant?.counts?.always
                      )
                    }
                  </span>
                </div>
                <img src={graphic_report} id={member.id} className="img-fluid" alt='graphic' />
              </div>
            </div>

            <div className="px-0 d-flex flex-column" style={{ width: '84px' }}>
              <div className="cursor-pointer mt-auto border-bottom pl-2">
                <h6 className="mb-0 font-weight-medium small py-2" >
                  Innovative
                  <span className='pl-1 font-weight-bold h6'>
                    {
                      member.talents &&
                      member.talents.map(quadrant =>
                        quadrant.quadrant === 'Innovative' &&
                        quadrant?.counts?.always
                      )
                    }
                  </span>
                </h6>
              </div>

              <div className="cursor-pointer mb-auto pl-2">
                <h6 className="mb-0 font-weight-medium small py-2" >
                  Relational
                  <span className='pl-1 font-weight-bold h6'>
                    {
                      member.talents &&
                      member.talents.map(quadrant =>
                        quadrant.quadrant === 'Relational' &&
                        quadrant?.counts?.always
                      )
                    }
                  </span>
                </h6>
              </div>
            </div>
          </div>
        </div>}

        {member.mind_pattern &&
          <div className="mind-patterns-content mb-3 text-center" onClick={() => hanndleNextSection({ section: 'detail-member-vaks', member_id: member.id })}>
            <h5>Mind Pattern</h5>
            <div className="mind-patterns-content d-flex justify-content-center py-2 gap-10">
              {member.mind_pattern.split("").map(
                (mp, k) => (
                  <React.Fragment key={k}>
                    <div className={`rounded-circle mind-pattern-area mind-pattern-area-sm ${mp === 'V' ? 'bg-visual' : (mp === 'A' ? 'bg-auditory' : 'bg-kinesthetic')} ${mp !== 'A' ? 'text-white' : ''}`} key={k}>{mp}</div>
                  </React.Fragment>
                ))}
            </div>
          </div>
        }

        <Modal isOpen={showModal} toggle={handleModal} className="pop-up-confirm">
          <ModalBody className="text-center p-4 p-md-5">
            <p>Are you sure you want to REMOVE {(member.first_name) ? `${member.first_name} ${member.last_name}` : member.username} from {team.name}?</p>
            <div className="d-flex justify-content-center">
              <Button color="btn text-uppercase rounded-pill btn-outline-primary mr-2 px-4" onClick={handleModal}><i className="mr-2 h5 text-reset align-middle"><FontAwesomeIcon icon={faTimesCircle} /></i><span className="h6 font-weight-normal text-reset align-middle">No</span></Button>{' '}
              <Button color="btn text-uppercase rounded-pill btn-outline-primary ml-2 px-4" onClick={(e) => handleModal(e, true)}><i className="mr-2 h5 text-reset align-middle"><FontAwesomeIcon icon={faCheckCircle} /></i><span className="h6 font-weight-normal text-reset align-middle">Yes</span></Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  removeTeamMember: teamActions.removeTeamMember,
  setLeaderTeamMember: teamActions.setLeaderTeamMember,
  loadTeamsReport: teamsReportListActions.loadTeamsReport,
};

export default connect(
  null,
  mapDispatchToProps
)(MemberDetail);